// extracted by mini-css-extract-plugin
export var container = "ShareWidget-module--container--18lsw";
export var block = "ShareWidget-module--block--1Tjy-";